import { ServiceWorkerModule } from '@angular/service-worker';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutePaths } from './enums';
import { BreadcrumbDefinition } from 'xng-breadcrumb/lib/types';
import { GoliathDocumentsPluginModule } from '@digiwall/goliath-documents';
import { appAccessGuard } from './app-access-guard';
import { homeLandingGuard } from './home-landing-guard';
import { GoliathProductsPluginModule } from '@digiwall/goliath-products';
import { GoliathContactsPluginModule } from '@digiwall/goliath-contacts';

const routes: Routes = [
  {
    path: 'access-denied',
    title: 'ERP::Menu:AccessDenied',
    loadChildren: () =>
      import('./access-denied/access-denied.module').then(m => m.AccessDeniedModule),
  },
  {
    path: '',
    canActivate: [appAccessGuard],
    children: [
      {
        path: 'reporting',
        loadChildren: () => import('@odyssey/reporting').then(m => m.ReportingModule.forLazy()),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: 'home',
        title: 'ERP::Menu:Home',
        canActivate: [homeLandingGuard],
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
      },
      {
        path: RoutePaths.General,
        data: {
          breadcrumb: {
            skip: true,
          } as BreadcrumbDefinition,
        },
        loadChildren: () =>
          import('@digiwall/goliath-core').then(m => m.GoliathCoreModule.forLazy()),
      },
      {
        path: RoutePaths.ThirdParty,
        data: {
          breadcrumb: {
            label: 'Contact::ThirdParties',
            alias: 'thirdParties',
          } as BreadcrumbDefinition,
        },
        loadChildren: () =>
          import('@digiwall/goliath-contacts').then(m => m.GoliathContactsModule.forLazy()),
      },
      {
        path: RoutePaths.Product,
        data: {
          breadcrumb: {
            label: 'Product::Stocks',
            alias: 'stocks',
          } as BreadcrumbDefinition,
        },
        loadChildren: () =>
          import('@digiwall/goliath-products').then(m => m.GoliathProductsModule.forLazy()),
      },
      {
        path: RoutePaths.Documents,
        data: {
          breadcrumb: {
            label: 'Doc::Documents',
            alias: 'documents',
          } as BreadcrumbDefinition,
        },
        loadChildren: () =>
          import('@digiwall/goliath-documents').then(m => m.GoliathDocumentsModule.forLazy()),
      },
      {
        path: RoutePaths.Shaping,
        loadChildren: () =>
          import('@digiwall/goliath-shaping-management').then(m =>
            m.GoliathShapingManagementModule.forLazy(),
          ),
      },
      {
        path: 'account',
        loadChildren: () => import('@abp/ng.account').then(m => m.AccountModule.forLazy()),
      },
      {
        path: RoutePaths.AccountingExport,
        data: {
          breadcrumb: {
            skip: true,
          },
        },
        loadChildren: () =>
          import('@digiwall/goliath-accounting').then(m => m.AccountingSynchronizationModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./features/goliath-features.module').then(m => m.GoliathFeaturesModule.forLazy()),
      },
      {
        path: 'production',
        data: {
          breadcrumb: {
            skip: true,
          },
        },
        loadChildren: () => import('@digiwall/goliath-documents').then(m => m.ProductionModule),
      },
      {
        path: 'service-work-order',
        data: {
          breadcrumb: {
            skip: true,
          },
        },
        loadChildren: () =>
          import('@digiwall/goliath-documents').then(m => m.ServiceWorkOrderModule),
      },
      {
        path: RoutePaths.Planning,
        data: {
          breadcrumb: {
            skip: true,
          },
        },
        loadChildren: () => import('@digiwall/goliath-documents').then(m => m.PlanningModule),
      },
      {
        path: 'identity',
        loadChildren: () => import('@abp/ng.identity').then(m => m.IdentityModule.forLazy()),
      },
      {
        path: 'features',
        loadChildren: () => import('@digiwall/core-features').then(m => m.FeatureModule),
      },
      {
        path: 'admin',
        data: {
          breadcrumb: {
            skip: true,
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: 'users',
            loadChildren: () => import('./users/user.module').then(m => m.UserModule),
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { bindToComponentInputs: true }),
    GoliathDocumentsPluginModule,
    GoliathProductsPluginModule,
    GoliathContactsPluginModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
